import { AgResourceLanguage } from '../types';
import { commonContent as EnUsCommonContent } from '../en-us/commonContent';

export const commonContent: AgResourceLanguage['commonContent'] = {
  ...EnUsCommonContent,
  orderBodyContent: {
    nextOnlyLabel: 'Única vez',
    outOfStockLabel: 'Agotado',
    quantityLabel: 'Cantidad:',
    productHiddenLabel: 'Producto',
    productsSubtitle: 'Productos',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Recomienda a tus amigos',
    text: 'Recibe €15 por cada amigo que recomiendes una vez que realicen su primera compra.'
  },
  slider: {
    empty: {
      title: 'Nuestras Suscripciones'
    },
    notEmpty: {
      title: 'La Tienda AG1',
      description: 'Exclusivamente disponible para miembros'
    },
    cardContent: {
      addToSubscription: 'Añadir a Suscripción',
      addedToSubscription: 'Añadido a Suscripción',
      addToNextOrder: 'Añadir a la Próxima Orden',
      addedToNextOrder: 'Añadido a la Próxima Orden',
      maxQuantityReached: 'Cantidad máxima alcanzada'
    }
  },
  buttons: {
    subscribeAndSave: 'Suscríbete y Ahorra',
    subscribe: 'Suscribirse',
    delete: 'Eliminar'
  },
  status: {
    fulfilled: 'Procesado',
    partial: 'Parcialmente procesado',
    paid: 'Envío en proceso',
    refunded: 'Reembolsado',
    partially: 'Parcialmente reembolsado',
    unpaid: 'No pagado'
  },
  statusV2: {
    Unfulfilled: 'Preparando',
    Fulfilled: 'Enviado',
    'On hold': 'Preparando'
  }
};
